







































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import CompanyService from '../../../services/company.service';
import { CompanyDto, CompanyListDto } from '../../../dto';
import { Pagination } from '../../../common';
import { APPROVAL_STATUS } from '../../../services/shared';

import { getStatusColor } from '../../../core/utils/status-color.util';

@Component({
  name: 'DashboardCompanyList',
})
export default class DashboardCompanyList extends BaseComponent {
  private pagination = new Pagination();
  private companyListDto = new CompanyListDto();
  private companyListCount = null;
  private companyDto: CompanyDto[] = [];
  private dataLoading = false;

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  getCompanyUpdateStatusList() {
    this.dataLoading = true;
    this.pagination.limit = 2;
    this.companyListDto.companyStatus = APPROVAL_STATUS.UPDATE_APPROVAL;
    CompanyService.findAll(this.companyListDto, this.pagination).subscribe(
      res => {
        this.dataLoading = false;
        this.companyDto = res.data.items;
        this.companyListCount = res.data.totalCount;
      },
    );
  }

  findOne(companyNo) {
    this.$router.push(`/company/${companyNo}`);
  }

  mounted() {
    this.getCompanyUpdateStatusList();
  }
}
